module.exports = __webpack_public_path__ + "152f16fcac46e58900b4424e28ba70bb.svg";